
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/preference-select.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-preference-select-demo-simple-service","docs-power-design-preference-select-demo-with-pro-table"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/preference-select.md?type=demo')
};